import {defineStore} from 'pinia';
import {ref} from 'vue';

interface MenuItemInterface {
  name: string;
  id: string;
  path?: string;
  icon?: string;
  activeIcon?: string;
  enable?: boolean;
  blank?: boolean;
  children?: Array<MenuItemInterface>;
}

export const menu = defineStore('menu', () => {
  const isCollapse = ref(false);

  function toggleCollapseStatus() {
    isCollapse.value = !isCollapse.value;
  }

  const menuList = ref([] as MenuItemInterface[]);

  function updateMenuList(list: MenuItemInterface[]) {
    const accType = aStore.get('accType')
    // menuList.value = list.filter(k=>{
    //   // 先做简单过滤， 后续有权限了整理逻辑
    //   if(k.id === 'systemMange'){
    //     return ['SuperMaster', 'Master'].includes(accType);
    //   }
    //   return true
    // });
    menuList.value = list
  }


  const currentMenu = reactive({
    list: [] as MenuItemInterface[],
  });

  function getBreadcrumbNames() {
    return currentMenu.list.map(k => {
      return k.name;
    });
  }

  function getCurrentMenu(path: string) {
    let currentList = [];
    for (let i = 0; i < menuList.value.length; i++) {
      const item = menuList.value[i];
      if (item.path === path) {
        currentList.push({
          name: item.name,
          id: item.id,
          path: item.path,
          icon: item.icon
        });
        return currentList;
      }
      if (item.children) {
        for (let j = 0; j < item.children.length; j++) {
          const subItem = item.children[j];
          if (subItem.path === path) {
            currentList.push({
              name: item.name,
              id: item.id,
              path: item.path,
              icon: item.icon
            });
            currentList.push({
              name: subItem.name,
              id: subItem.id,
              path: subItem.path,
              icon: subItem.icon
            });
            return currentList;
          }
        }
      }
    }
  }

  function updateCurrentMenu(path: string) {
    currentMenu.list = getCurrentMenu(path) || [];
  }


  const authList = ref([] as MenuItemInterface[]);
  function updateAuthList(list: MenuItemInterface[]) {
    authList.value = list
  }


  return {isCollapse, menuList, authList, toggleCollapseStatus, getBreadcrumbNames, updateCurrentMenu, updateMenuList, updateAuthList};

});
